import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  competencesSearchResult: undefined,
  closingExceptionsSearchResult: undefined,
  currentCompetence: undefined,
  closingExceptionCategories: [],
}

export default {
  state,
  actions,
  getters,
  mutations,
}
